import { render, staticRenderFns } from "./LegendItem.vue?vue&type=template&id=917e2cd4&scoped=true&"
import script from "./LegendItem.vue?vue&type=script&lang=js&"
export * from "./LegendItem.vue?vue&type=script&lang=js&"
import style0 from "./LegendItem.vue?vue&type=style&index=0&id=917e2cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917e2cd4",
  null
  
)

export default component.exports